import { ParkRide } from "../types";
import {
  ABUGSLIFE,
  ALADDIN,
  AVATAR,
  AVATARTHEWAYOFWATER,
  BEAUTYANDTHEBEAST,
  DINOSAUR as DINOSAURFILM,
  DUMBO,
  DUMBO2019,
  FINDINGDORY,
  FINDINGNEMOFILM,
  FROZEN,
  GUARDIANSOFTHEGALAXYFILM,
  GUARDIANSOFTHEGALAXYVOL2,
  GUARDIANSOFTHEGALAXYVOL3,
  HAUNTEDMANSION2023,
  MANYADVENTURESOFWINNIETHEPOOH,
  MICKEYMOUSE,
  MONSTERSINCFILM,
  MONSTERSUNIVERSITY,
  MOANA,
  PETERPAN,
  PETERPANANDWENDY,
  PIRATES1,
  PIRATES2,
  PIRATES3,
  PRINCESSANDFROG,
  RATATOUILLE,
  SNOWWHITEANDTHESEVENDWARVES,
  STARWARSANEWHOPE,
  STARWARSATTACKOFTHECLONES,
  STARWARSRETURNOFTHEJEDI,
  STARWARSREVENGEOFTHESITH,
  STARWARSTHEEMPIRE,
  STARWARSTHEFORCEAWAKENS,
  STARWARSTHELASTJEDI,
  STARWARSTHEPHANTOMMENACE,
  STARWARSTHERISEOFSKYWALKER,
  SWISSFAMILYROBINSON,
  THEHAUNTEDMANSION,
  THEJUNGLEBOOK,
  THELIONKING,
  THELIONKING2019,
  THELITTLEMERMAID2023,
  THELITTLEMERMAIDFILM,
  THEMANDALORIAN,
  THEMUPPETMOVIE,
  THETHREECABALLEROS,
  TOYSTORY,
  TOYSTORY2,
  TOYSTORY3,
  TOYSTORY4,
  TRON,
  TRONLEGACY,
  TWILIGHTZONE,
  WINNIEPOOH,
  AHSOKA,
  JUNGLECRUISE,
  ALICEINWONDERLANDFILM,
} from "./movies";

// ============================================================
// MAGIC KINGDOM
// ============================================================

export const MK_SPACEMOUNTAIN: ParkRide = {
  geo: [28.41895, -81.57769],
  title: "Space Mountain",
  type: "Roller Coaster",
  year: 1975,
  heightRequirement: 44,
  description:
    "Blast off on a thrilling rocket ride through the darkness of outer space on this iconic indoor coaster.",
  relatedFilms: [],
  background: "",
};

export const MK_TRONLIGHTCYCLERUN: ParkRide = {
  geo: [28.42055, -81.57673],
  title: "TRON Lightcycle / Run",
  type: "Roller Coaster",
  year: 2023,
  heightRequirement: 48,
  description:
    "Board a Lightcycle and launch into the Grid on one of the fastest coasters in any Disney park.",
  relatedFilms: [{ ...TRON, primaryAdaptation: true }, TRONLEGACY],
  background: "",
};

export const MK_BIGTHUNDERMOUNTAIN: ParkRide = {
  geo: [28.41987, -81.58441],
  title: "Big Thunder Mountain Railroad",
  type: "Roller Coaster",
  year: 1980,
  heightRequirement: 40,
  description:
    "Hold on to your hats as you race through a haunted gold mine aboard a runaway train.",
  relatedFilms: [],
  background: "",
};

export const MK_SEVENDWARFSMINETRAIN: ParkRide = {
  geo: [28.4204, -81.58058],
  title: "Seven Dwarfs Mine Train",
  type: "Roller Coaster",
  year: 2014,
  heightRequirement: 38,
  description:
    "Race through the diamond mine where the Seven Dwarfs work on this family-friendly coaster with swaying cars.",
  relatedFilms: [{ ...SNOWWHITEANDTHESEVENDWARVES, primaryAdaptation: true }],
  background: "",
};

export const MK_HAUNTEDMANSION: ParkRide = {
  geo: [28.42069, -81.58299],
  title: "Haunted Mansion",
  type: "Dark Ride",
  year: 1971,
  heightRequirement: 0,
  description:
    "Glide past 999 happy haunts in your Doom Buggy through this eerily enchanted estate.",
  relatedFilms: [THEHAUNTEDMANSION, HAUNTEDMANSION2023],
  background: "",
};

export const MK_PIRATESOFTHECARIBBEAN: ParkRide = {
  geo: [28.4181, -81.58448],
  title: "Pirates of the Caribbean",
  type: "Boat Ride",
  year: 1973,
  heightRequirement: 0,
  description:
    "Set sail through a swashbuckling world of marauding pirates and buried treasure.",
  relatedFilms: [PIRATES1, PIRATES2, PIRATES3],
  background: "",
};

export const MK_JUNGLECRUISE: ParkRide = {
  geo: [28.41806, -81.58348],
  title: "Jungle Cruise",
  type: "Boat Ride",
  year: 1971,
  heightRequirement: 0,
  description:
    "Embark on a scenic and pun-filled boat tour along some of the most exotic rivers in the world.",
  relatedFilms: [JUNGLECRUISE, THEJUNGLEBOOK],
  background: "",
};

export const MK_TIANASBAYOUADVENTURE: ParkRide = {
  geo: [28.41933, -81.58506],
  title: "Tiana's Bayou Adventure",
  type: "Water Ride",
  year: 2024,
  heightRequirement: 40,
  description:
    "Join Princess Tiana on a musical adventure through the bayou with a thrilling five-story plunge.",
  relatedFilms: [{ ...PRINCESSANDFROG, primaryAdaptation: true }],
  background: "",
};

export const MK_PETERPANSFLIGHT: ParkRide = {
  geo: [28.42047, -81.58178],
  title: "Peter Pan's Flight",
  type: "Dark Ride",
  year: 1971,
  heightRequirement: 0,
  description:
    "Soar in a magical pirate ship over moonlit London and into Never Land.",
  relatedFilms: [{ ...PETERPAN, primaryAdaptation: true }, PETERPANANDWENDY],
  background: "",
};

export const MK_ITSASMALLWORLD: ParkRide = {
  geo: [28.42098, -81.58145],
  title: "it's a small world",
  type: "Boat Ride",
  year: 1971,
  heightRequirement: 0,
  description:
    "Cruise through a whimsical world of singing children representing cultures from around the globe.",
  relatedFilms: [],
  background: "",
};

export const MK_BUZZLIGHTYEAR: ParkRide = {
  geo: [28.41858, -81.57916],
  title: "Buzz Lightyear's Space Ranger Spin",
  type: "Dark Ride",
  year: 1998,
  heightRequirement: 0,
  description:
    "Blast targets with your laser cannon to help Buzz defeat the Evil Emperor Zurg.",
  relatedFilms: [{ ...TOYSTORY, primaryAdaptation: true }, TOYSTORY2],
  background: "",
};

export const MK_WINNIETHEPOOH: ParkRide = {
  geo: [28.42033, -81.58],
  title: "The Many Adventures of Winnie the Pooh",
  type: "Dark Ride",
  year: 1999,
  heightRequirement: 0,
  description:
    "Hop aboard a honey pot and bounce through the Hundred Acre Wood with Pooh and friends.",
  relatedFilms: [
    { ...MANYADVENTURESOFWINNIETHEPOOH, primaryAdaptation: true },
    WINNIEPOOH,
  ],
  background: "",
};

export const MK_UNDERTHESEA: ParkRide = {
  geo: [28.4214, -81.57968],
  title: "Under the Sea ~ Journey of The Little Mermaid",
  type: "Dark Ride",
  year: 2012,
  heightRequirement: 0,
  description:
    "Descend beneath the waves in a clamshell to relive Ariel's story with beloved songs and scenes.",
  relatedFilms: [
    { ...THELITTLEMERMAIDFILM, primaryAdaptation: true },
    THELITTLEMERMAID2023,
  ],
  background: "",
};

export const MK_BARNSTORMER: ParkRide = {
  geo: [28.42106, -81.57877],
  title: "The Barnstormer",
  type: "Roller Coaster",
  year: 1996,
  heightRequirement: 35,
  description:
    "Swoop and soar on a rollicking junior coaster that zooms through Goofy's daredevil stunt-plane set.",
  relatedFilms: [],
  background: "",
};

export const MK_DUMBO: ParkRide = {
  geo: [28.42065, -81.57866],
  title: "Dumbo the Flying Elephant",
  type: "Carousel",
  year: 1971,
  heightRequirement: 0,
  description:
    "Soar high in the sky aboard the beloved flying elephant on this classic spinner.",
  relatedFilms: [{ ...DUMBO, primaryAdaptation: true }, DUMBO2019],
  background: "",
};

export const MK_MADTEAPARTY: ParkRide = {
  geo: [28.42024, -81.57926],
  title: "Mad Tea Party",
  type: "Spinning Ride",
  year: 1971,
  heightRequirement: 0,
  description:
    "Spin inside an oversized teacup at the Unbirthday Party inspired by Alice in Wonderland.",
  relatedFilms: [{ ...ALICEINWONDERLANDFILM, primaryAdaptation: true }],
  background: "",
};

export const MK_PRINCECHARMINGREGALCARROUSEL: ParkRide = {
  geo: [28.42009, -81.58082],
  title: "Prince Charming Regal Carrousel",
  type: "Carousel",
  year: 1971,
  heightRequirement: 0,
  description:
    "Gallop on a majestic steed aboard this classic carousel in the heart of Fantasyland.",
  relatedFilms: [],
  background: "",
};

export const MK_TOMORROWLANDSPEEDWAY: ParkRide = {
  geo: [28.41875, -81.57674],
  title: "Tomorrowland Speedway",
  type: "Other",
  year: 1971,
  heightRequirement: 32,
  description:
    "Get behind the wheel and cruise along a winding outdoor raceway on this classic driving attraction.",
  relatedFilms: [],
  background: "",
};

export const MK_ASTROORBITER: ParkRide = {
  geo: [28.41826, -81.57927],
  title: "Astro Orbiter",
  type: "Spinning Ride",
  year: 1974,
  heightRequirement: 0,
  description:
    "Pilot a retro rocket ship high above Tomorrowland on this elevated spinner.",
  relatedFilms: [],
  background: "",
};

export const MK_MAGICCARPETSOFALADDIN: ParkRide = {
  geo: [28.41842, -81.58377],
  title: "The Magic Carpets of Aladdin",
  type: "Spinning Ride",
  year: 2001,
  heightRequirement: 0,
  description:
    "Soar on a magic carpet around an enchanted genie lamp in the bazaar of Agrabah.",
  relatedFilms: [{ ...ALADDIN, primaryAdaptation: true }],
  background: "",
};

export const MK_SWISSFAMILYTREEHOUSE: ParkRide = {
  geo: [28.4183, -81.58319],
  title: "Swiss Family Treehouse",
  type: "Other",
  year: 1971,
  heightRequirement: 0,
  description:
    "Explore the ingenious treehouse home of the shipwrecked Swiss Family Robinson.",
  relatedFilms: [{ ...SWISSFAMILYROBINSON, primaryAdaptation: true }],
  background: "",
};

export const MK_CAROUSELOFPROGRESS: ParkRide = {
  geo: [28.41775, -81.5783],
  title: "Walt Disney's Carousel of Progress",
  type: "Entertainment",
  year: 1975,
  heightRequirement: 0,
  description:
    "Experience a rotating theater show that celebrates 100 years of technological innovation in American life.",
  relatedFilms: [],
  background: "",
};

export const MK_PEOPLEMOVER: ParkRide = {
  geo: [28.41836, -81.57879],
  title: "Tomorrowland Transit Authority PeopleMover",
  type: "Transportation",
  year: 1975,
  heightRequirement: 0,
  description:
    "Glide on a narrated scenic tour high above Tomorrowland aboard this relaxing elevated tram.",
  relatedFilms: [],
  background: "",
};

export const MK_COUNTRYBEARJAMBOREE: ParkRide = {
  geo: [28.41946, -81.58363],
  title: "Country Bear Jamboree",
  type: "Entertainment",
  year: 1971,
  heightRequirement: 0,
  description:
    "Sit back and enjoy a hilarious hootenanny performed by a cast of Audio-Animatronics bears.",
  relatedFilms: [],
  background: "",
};

export const MK_HALLOFPRESIDENTS: ParkRide = {
  geo: [28.42023, -81.58362],
  title: "The Hall of Presidents",
  type: "Entertainment",
  year: 1971,
  heightRequirement: 0,
  description:
    "Witness every U.S. President brought to life through Audio-Animatronics in this patriotic stage show.",
  relatedFilms: [],
  background: "",
};

export const MK_PHILHARMAGIC: ParkRide = {
  geo: [28.42023, -81.58146],
  title: "Mickey's PhilharMagic",
  type: "Entertainment",
  year: 2003,
  heightRequirement: 0,
  description:
    "Don 3D glasses for a musical romp through classic Disney film scenes with Donald Duck.",
  relatedFilms: [
    PETERPAN,
    ALADDIN,
    THELITTLEMERMAIDFILM,
    BEAUTYANDTHEBEAST,
    THELIONKING,
  ],
  background: "",
};

export const MK_MONSTERSINCLAUGHFLOOR: ParkRide = {
  geo: [28.41787, -81.57933],
  title: "Monsters, Inc. Laugh Floor",
  type: "Entertainment",
  year: 2007,
  heightRequirement: 0,
  description:
    "Interact with live Monster comedians in this improvisational comedy show from the world of Monsters, Inc.",
  relatedFilms: [
    { ...MONSTERSINCFILM, primaryAdaptation: true },
    MONSTERSUNIVERSITY,
  ],
  background: "",
};

export const MK_TOMSAWYERISLAND: ParkRide = {
  geo: [28.41953, -81.58502],
  title: "Tom Sawyer Island",
  type: "Other",
  year: 1973,
  heightRequirement: 0,
  description:
    "Raft over to a rugged island for caves, bridges, and frontier exploration.",
  relatedFilms: [],
  background: "",
};

export const MK_LIBERTYBELLERIVERBOAT: ParkRide = {
  geo: [28.41992, -81.58404],
  title: "Liberty Belle Riverboat",
  type: "Boat Ride",
  year: 1973,
  heightRequirement: 0,
  description:
    "Cruise the Rivers of America aboard a stately steam-powered paddlewheel riverboat.",
  relatedFilms: [],
  background: "",
};

// ============================================================
// EPCOT
// ============================================================

export const EP_SPACESHIPEARTH: ParkRide = {
  geo: [28.37549, -81.54924],
  title: "Spaceship Earth",
  type: "Dark Ride",
  year: 1982,
  heightRequirement: 0,
  description:
    "Travel through time inside the iconic geodesic sphere to witness the history of human communication.",
  relatedFilms: [],
  background: "",
};

export const EP_TESTTRACK: ParkRide = {
  geo: [28.3734, -81.54713],
  title: "Test Track",
  type: "Other",
  year: 1999,
  heightRequirement: 40,
  description:
    "Design a virtual concept car, then buckle up for a high-speed road test reaching 65 mph.",
  relatedFilms: [],
  background: "",
};

export const EP_FROZENEVERAFTER: ParkRide = {
  geo: [28.37095, -81.54618],
  title: "Frozen Ever After",
  type: "Boat Ride",
  year: 2016,
  heightRequirement: 0,
  description:
    "Sail through the kingdom of Arendelle and relive the magic of Frozen with Anna, Elsa, and friends.",
  relatedFilms: [{ ...FROZEN, primaryAdaptation: true }],
  background: "",
};

export const EP_REMYSRATATOUILLEADVENTURE: ParkRide = {
  geo: [28.36854, -81.55275],
  title: "Remy's Ratatouille Adventure",
  type: "Dark Ride",
  year: 2021,
  heightRequirement: 0,
  description:
    "Shrink down to the size of Chef Remy and scurry through Gusteau's restaurant in this trackless 4D ride.",
  relatedFilms: [{ ...RATATOUILLE, primaryAdaptation: true }],
  background: "",
};

export const EP_COSMICREWIND: ParkRide = {
  geo: [28.37464, -81.54694],
  title: "Guardians of the Galaxy: Cosmic Rewind",
  type: "Roller Coaster",
  year: 2022,
  heightRequirement: 42,
  description:
    "Blast off on a reverse-launch indoor coaster through space alongside the Guardians of the Galaxy.",
  relatedFilms: [
    { ...GUARDIANSOFTHEGALAXYFILM, primaryAdaptation: true },
    GUARDIANSOFTHEGALAXYVOL2,
    GUARDIANSOFTHEGALAXYVOL3,
  ],
  background: "",
};

export const EP_SOARIN: ParkRide = {
  geo: [28.37333, -81.55177],
  title: "Soarin' Around the World",
  type: "Motion Simulator",
  year: 2005,
  heightRequirement: 40,
  description:
    "Hang-glide over breathtaking landmarks from around the globe on this exhilarating flight simulator.",
  relatedFilms: [],
  background: "",
};

export const EP_LIVINGWITHTHELAND: ParkRide = {
  geo: [28.37372, -81.55186],
  title: "Living with the Land",
  type: "Boat Ride",
  year: 1982,
  heightRequirement: 0,
  description:
    "Cruise through greenhouses and discover innovative agricultural techniques and growing methods.",
  relatedFilms: [],
  background: "",
};

export const EP_SEASWITHNEMO: ParkRide = {
  geo: [28.37496, -81.55103],
  title: "The Seas with Nemo & Friends",
  type: "Dark Ride",
  year: 2006,
  heightRequirement: 0,
  description:
    "Board a clamobile and journey through the ocean with Nemo, Dory, and friends from Finding Nemo.",
  relatedFilms: [{ ...FINDINGNEMOFILM, primaryAdaptation: true }, FINDINGDORY],
  background: "",
};

export const EP_JOURNEYOFWATER: ParkRide = {
  geo: [28.37406, -81.54801],
  title: "Journey of Water, Inspired by Moana",
  type: "Other",
  year: 2023,
  heightRequirement: 0,
  description:
    "Explore an interactive water trail inspired by Moana and learn how water cycles through our world.",
  relatedFilms: [{ ...MOANA, primaryAdaptation: true }],
  background: "",
};

export const EP_GRANFIESTATOUR: ParkRide = {
  geo: [28.37026, -81.54714],
  title: "Gran Fiesta Tour Starring The Three Caballeros",
  type: "Boat Ride",
  year: 2007,
  heightRequirement: 0,
  description:
    "Float through a festive Mexican scene searching for Donald Duck with José and Panchito.",
  relatedFilms: [{ ...THETHREECABALLEROS, primaryAdaptation: true }],
  background: "",
};

export const EP_MISSIONSPACE: ParkRide = {
  geo: [28.37369, -81.54562],
  title: "Mission: SPACE",
  type: "Motion Simulator",
  year: 2003,
  heightRequirement: 44,
  description:
    "Experience the sensation of a rocket launch and journey to Mars on this intense centrifuge simulator.",
  relatedFilms: [],
  background: "",
};

export const EP_TURTLETALK: ParkRide = {
  geo: [28.37481, -81.55024],
  title: "Turtle Talk with Crush",
  type: "Entertainment",
  year: 2004,
  heightRequirement: 0,
  description:
    "Chat live with Crush, the totally tubular sea turtle from Finding Nemo.",
  relatedFilms: [{ ...FINDINGNEMOFILM, primaryAdaptation: true }, FINDINGDORY],
  background: "",
};

// ============================================================
// HOLLYWOOD STUDIOS
// ============================================================

export const HS_RISEOFTHERESISTANCE: ParkRide = {
  geo: [28.3549, -81.55978],
  title: "Star Wars: Rise of the Resistance",
  type: "Dark Ride",
  year: 2019,
  heightRequirement: 40,
  description:
    "Join the Resistance in an epic battle against the First Order on this massive, multi-phase attraction.",
  relatedFilms: [
    STARWARSTHEFORCEAWAKENS,
    STARWARSTHELASTJEDI,
    { ...STARWARSTHERISEOFSKYWALKER, primaryAdaptation: true },
  ],
  background: "",
};

export const HS_SMUGGLERSRUN: ParkRide = {
  geo: [28.3537, -81.56095],
  title: "Millennium Falcon: Smugglers Run",
  type: "Motion Simulator",
  year: 2019,
  heightRequirement: 38,
  description:
    "Take the controls of the Millennium Falcon on an interactive smuggling mission at Black Spire Outpost.",
  relatedFilms: [
    STARWARSANEWHOPE,
    STARWARSTHEEMPIRE,
    STARWARSRETURNOFTHEJEDI,
    STARWARSTHEFORCEAWAKENS,
    STARWARSTHELASTJEDI,
    { ...STARWARSTHERISEOFSKYWALKER, primaryAdaptation: true },
  ],
  background: "",
};

export const HS_TOWEROFTERROR: ParkRide = {
  geo: [28.35931, -81.55949],
  title: "The Twilight Zone Tower of Terror",
  type: "Dark Ride",
  year: 1994,
  heightRequirement: 40,
  description:
    "Step into a haunted Hollywood hotel and plunge 13 stories in a possessed elevator.",
  relatedFilms: [{ ...TWILIGHTZONE, primaryAdaptation: true }],
  background: "",
};

export const HS_ROCKNROLLERCOASTER: ParkRide = {
  geo: [28.35964, -81.56034],
  title: "Rock 'n' Roller Coaster Starring Aerosmith",
  type: "Roller Coaster",
  year: 1999,
  heightRequirement: 48,
  description:
    "Launch from 0 to 57 mph in 2.8 seconds on this indoor looping coaster set to Aerosmith's greatest hits.",
  relatedFilms: [],
  background: "",
};

export const HS_SLINKYDOGDASH: ParkRide = {
  geo: [28.35561, -81.5622],
  title: "Slinky Dog Dash",
  type: "Roller Coaster",
  year: 2018,
  heightRequirement: 38,
  description:
    "Ride Slinky Dog around Andy's backyard on this family-friendly coaster in Toy Story Land.",
  relatedFilms: [TOYSTORY, TOYSTORY2, TOYSTORY3, TOYSTORY4],
  background: "",
};

export const HS_TOYSTORYMANIA: ParkRide = {
  geo: [28.35595, -81.56154],
  title: "Toy Story Mania!",
  type: "Dark Ride",
  year: 2008,
  heightRequirement: 0,
  description:
    "Put on 3D glasses and blast targets in this midway-style shooting game with Toy Story pals.",
  relatedFilms: [TOYSTORY, TOYSTORY2, TOYSTORY3, TOYSTORY4],
  background: "",
};

export const HS_MICKEYMINNIERUNAWAY: ParkRide = {
  geo: [28.35683, -81.55889],
  title: "Mickey & Minnie's Runaway Railway",
  type: "Dark Ride",
  year: 2020,
  heightRequirement: 0,
  description:
    "Step through the movie screen into a zany cartoon world with Mickey and Minnie on this trackless ride.",
  relatedFilms: [{ ...MICKEYMOUSE, primaryAdaptation: true }],
  background: "",
};

export const HS_ALIENSWIRLING: ParkRide = {
  geo: [28.35527, -81.56132],
  title: "Alien Swirling Saucers",
  type: "Spinning Ride",
  year: 2018,
  heightRequirement: 32,
  description:
    "Spin and whirl in a toy flying saucer piloted by the little green aliens from Toy Story.",
  relatedFilms: [{ ...TOYSTORY, primaryAdaptation: true }],
  background: "",
};

export const HS_STARTOURS: ParkRide = {
  geo: [28.35537, -81.55847],
  title: "Star Tours - The Adventures Continue",
  type: "Motion Simulator",
  year: 1989,
  heightRequirement: 40,
  description:
    "Blast off on a 3D flight simulator to random destinations across the Star Wars galaxy.",
  relatedFilms: [
    STARWARSTHEPHANTOMMENACE,
    STARWARSATTACKOFTHECLONES,
    STARWARSREVENGEOFTHESITH,
    STARWARSANEWHOPE,
    STARWARSTHEEMPIRE,
    STARWARSRETURNOFTHEJEDI,
    STARWARSTHEFORCEAWAKENS,
    STARWARSTHELASTJEDI,
    STARWARSTHERISEOFSKYWALKER,
    THEMANDALORIAN,
    AHSOKA,
  ],
  background: "",
};

export const HS_MUPPETVISION: ParkRide = {
  geo: [28.3552, -81.55623],
  title: "MuppetVision 3D",
  type: "Entertainment",
  year: 1991,
  heightRequirement: 0,
  description:
    "Enjoy a hilarious 3D movie experience hosted by Kermit and the Muppets in their laboratory theater.",
  relatedFilms: [{ ...THEMUPPETMOVIE, primaryAdaptation: true }],
  background: "",
};

// ============================================================
// ANIMAL KINGDOM
// ============================================================

export const AK_FLIGHTOFPASSAGE: ParkRide = {
  geo: [28.35539, -81.59211],
  title: "Avatar Flight of Passage",
  type: "Motion Simulator",
  year: 2017,
  heightRequirement: 44,
  description:
    "Link with an Avatar and soar on a banshee over the breathtaking world of Pandora.",
  relatedFilms: [
    { ...AVATAR, primaryAdaptation: true },
    AVATARTHEWAYOFWATER,
  ],
  background: "",
};

export const AK_NAVIRIVERJOURNEY: ParkRide = {
  geo: [28.35616, -81.59106],
  title: "Na'vi River Journey",
  type: "Boat Ride",
  year: 2017,
  heightRequirement: 0,
  description:
    "Drift through the bioluminescent rainforest of Pandora on a gentle boat ride.",
  relatedFilms: [
    { ...AVATAR, primaryAdaptation: true },
    AVATARTHEWAYOFWATER,
  ],
  background: "",
};

export const AK_EXPEDITIONEVEREST: ParkRide = {
  geo: [28.35784, -81.58734],
  title: "Expedition Everest - Legend of the Forbidden Mountain",
  type: "Roller Coaster",
  year: 2006,
  heightRequirement: 44,
  description:
    "Race forward and backward through the Himalayas while avoiding the fearsome Yeti on this thrilling coaster.",
  relatedFilms: [],
  background: "",
};

export const AK_KILIMANJAROSAFARIS: ParkRide = {
  geo: [28.35917, -81.59177],
  title: "Kilimanjaro Safaris",
  type: "Other",
  year: 1998,
  heightRequirement: 0,
  description:
    "Embark on an open-air safari through the African savanna to spot real animals in their habitats.",
  relatedFilms: [THELIONKING, THELIONKING2019],
  background: "",
};

export const AK_DINOSAUR: ParkRide = {
  geo: [28.35513, -81.58797],
  title: "DINOSAUR",
  type: "Dark Ride",
  year: 1998,
  heightRequirement: 40,
  description:
    "Travel back in time on a jerky Time Rover to rescue an Iguanodon before a meteor strike.",
  relatedFilms: [{ ...DINOSAURFILM, primaryAdaptation: true }],
  background: "",
};

export const AK_KALIRIVERRAPIDS: ParkRide = {
  geo: [28.35953, -81.58862],
  title: "Kali River Rapids",
  type: "Water Ride",
  year: 1999,
  heightRequirement: 38,
  description:
    "Brave the raging rapids of the Chakranadi River on a whitewater raft adventure through the jungle.",
  relatedFilms: [],
  background: "",
};

export const AK_TRICERATOPSPIN: ParkRide = {
  geo: [28.3544, -81.58835],
  title: "TriceraTop Spin",
  type: "Spinning Ride",
  year: 2001,
  heightRequirement: 0,
  description:
    "Take flight on a friendly Triceratops on this Dumbo-style spinner in DinoLand U.S.A.",
  relatedFilms: [DINOSAURFILM],
  background: "",
};

export const AK_ITSTOUGHTOBEABUG: ParkRide = {
  geo: [28.35755, -81.59009],
  title: "It's Tough to be a Bug!",
  type: "Entertainment",
  year: 1998,
  heightRequirement: 0,
  description:
    "Experience a 3D show inside the Tree of Life with Flik and friends from A Bug's Life.",
  relatedFilms: [{ ...ABUGSLIFE, primaryAdaptation: true }],
  background: "",
};
